// extracted by mini-css-extract-plugin
export default {"textInput":"StyledTextInput_textInput__H0YNq","error":"StyledTextInput_error__r5GW7"};